// extracted by mini-css-extract-plugin
export default {"h4Box":"CreateResource_h4Box__2MA31"};